module.exports = {"TXTCLI_Code":{"id":"TXTCLI_Code","defaultMessage":"Κωδικός","track":"Code"}}